export function recipientsFromFormValues(formValues) {
    let recipient = '';
    let cc = '';
    let bcc = '';
    if (formValues.recipient && Array.isArray(formValues.recipient)) {
        recipient = formValues.recipient.join(', ');
    } else if (formValues.recipient && typeof formValues.recipient === 'string') {
        recipient = formValues.recipient.trim();
    }
    if (formValues.cc && Array.isArray(formValues.cc)) {
        cc = formValues.cc.join(', ');
    } else if (formValues.cc && typeof formValues.cc === 'string') {
        cc = formValues.cc.trim();
    }
    if (formValues.bcc && Array.isArray(formValues.bcc)) {
        bcc = formValues.bcc.join(', ');
    } else if (formValues.bcc && typeof formValues.bcc === 'string') {
        bcc = formValues.bcc.trim();
    }
    return { recipient, cc, bcc };
}

export function serializeCommentForDraftPayload(c) {
    return {
        content: c.content,
        page: c.page ?? 1,
        position_x: c.position_x ?? 50,
        position_y: c.position_y ?? 50,
        width: c.width ?? 25,
        height: c.height ?? 10,
    };
}

export function appendDocumensoAttachmentPayload(params, {
    fileList,
    signatureFields,
    draftFileComments,
    localFileComments,
}) {
    const draftFileIds = fileList.filter((f) => f.isDraftFile).map((f) => f.uid);
    const newFiles = fileList.filter((f) => !f.isDraftFile && (f.originFileObj || f));
    params.append('existing_draft_file_ids', JSON.stringify(draftFileIds));
    if (signatureFields && Object.keys(signatureFields).length > 0) {
        params.append('signature_fields', JSON.stringify(signatureFields));
    }
    const attachmentDraftCommentsPayload = {};
    draftFileIds.forEach((fid) => {
        const list = draftFileComments[fid];
        if (Array.isArray(list) && list.length > 0) {
            attachmentDraftCommentsPayload[fid] = list.map(serializeCommentForDraftPayload);
        }
    });
    params.append('attachment_draft_comments', JSON.stringify(attachmentDraftCommentsPayload));
    const attachmentLocalCommentsPayload = newFiles.map((f) => {
        const list = localFileComments[f.uid] || [];
        return Array.isArray(list) ? list.map(serializeCommentForDraftPayload) : [];
    });
    params.append('attachment_local_comments', JSON.stringify(attachmentLocalCommentsPayload));
    return { draftFileIds, newFiles };
}

export async function postDocumensoSaveDraft(axios, params, newFiles) {
    if (newFiles.length > 0) {
        const formData = new FormData();
        for (const [k, v] of params.entries()) formData.append(k, v);
        newFiles.forEach((f) => {
            const raw = f.originFileObj || f;
            if (raw) formData.append('attachments', raw, raw.name || f.name || 'file');
        });
        return axios.post('/api/docuso/save_draft/', formData);
    }
    return axios.post('/api/docuso/save_draft/', params, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
}
